import { render, staticRenderFns } from "./EditSponsors.vue?vue&type=template&id=62687528&"
import script from "./EditSponsors.vue?vue&type=script&lang=js&"
export * from "./EditSponsors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports